// Earth share-URL parsing (ERT-6, ATL-8 pattern). `?earth=lat,lon[,scale]` boots
// directly into an Earth world at those coordinates; a bare `?earth` (or a malformed
// value) resolves to the offline KHFD default. Pure — no DOM — so it unit-tests
// without a browser. `scale` is metres/block (default 0.9144 = 3 ft, per ERT-1),
// distinct from Atlas's default of 1.
import { EARTH } from '../../sim/config';

/** Parsed coordinates for `?earth=…`. No `lat` ⇒ the default KHFD location. */
export interface EarthDeepLink {
  lat?: number;
  lon?: number;
  scaleM: number;
}

/**
 * Parse the value of `?earth=` into a location request. Accepts `lat,lon` and an
 * optional third `scale` (metres/block); negatives and decimals are honoured.
 * Anything not a valid lat,lon pair (empty, one number, non-numeric) → the default
 * KHFD location at the 3 ft/block scale.
 */
export function parseEarthParam(val: string | null | undefined): EarthDeepLink {
  // An empty component (`Number('')` is 0, not NaN) must count as malformed.
  const parts = val ? val.split(',').map((s) => (s.trim() === '' ? NaN : Number(s.trim()))) : [];
  const [lat, lon, scale] = parts;
  const scaleM = parts.length >= 3 && Number.isFinite(scale) && scale! > 0 ? scale! : EARTH.DEFAULT.scaleM;
  if (parts.length >= 2 && Number.isFinite(lat) && Number.isFinite(lon)) {
    return { lat, lon, scaleM };
  }
  return { scaleM: EARTH.DEFAULT.scaleM };
}
